<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

import { reactiveOmit } from '@vueuse/core'
import { cn } from '~ds/lib/utils'
import { Primitive } from 'reka-ui'

import type { TextVariants } from '.'

import { textVariants } from '.'

const props = withDefaults(defineProps<PrimitiveProps & {
  size?: TextVariants['size'];
  weight?: TextVariants['weight'];
  variant?: TextVariants['variant'];
  class?: HTMLAttributes['class'];
}>(), {
  as: 'p',
})

const delegatedProps = reactiveOmit(props, 'class', 'size', 'weight', 'variant')
</script>

<template>
  <Primitive
    data-slot="text"
    :class="cn(textVariants({ size, weight, variant }), props.class)"
    v-bind="delegatedProps"
  >
    <slot />
  </Primitive>
</template>
